import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

// const GridItemContainer = ({ children }) => {
const GridItemContainer = React.forwardRef((props, ref) => {
  return (
    <Grid item container spacing={3} ref={ref}>
      {props.children}
    </Grid>
  );
});

export default GridItemContainer;

GridItemContainer.propTypes = {
  children: PropTypes.node,
};
